export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const capitalizeFirstLetterOfEachWord = (str) => {
  if (!str) return "";
  return str.replace(/\b\w/g, (match) => match.toUpperCase());
};
